// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"afd0be08","185":"36562fa8","381":"1700ca11","400":"e1a53000","786":"6a171f96","947":"54fdbedd","979":"66298925"}[chunkId] + ".chunk.js";
};